module.exports = __webpack_public_path__ + "img/world-bottom-left.0246ac10.png";